import { AxiosRequestConfig } from 'axios';
import { store } from '../../../web-legacy/appStore';
import { UserInfo } from '../../../web-legacy/models/apiModels';
import { Environment } from '../../../web-legacy/models/constants/constants';
import { IAppState } from '../../../web-legacy/models/reduxState';
import { isGetHelpSelector, isThirdPartySelector } from '../../../web-legacy/packages/app/selectors/contactUsSelector';
import { EmeraldConfigResponseModel } from '../../../web-legacy/packages/contactUs/models/configModels';
import {
  FormUrlEncodedHeaders,
  addAppNamesToParam,
  addExpGuidToParam,
  addMarketToUrl,
} from '../../../web-legacy/utilities';
import { httpUtils } from './httpUtils';
import { inEmsSession } from '../../../common/utils/commonUtilities';

export const getEmeraldConfigApi = async (
  host: string,
  platform: string,
  market: string,
  version: string,
  namespace: string,
  LCID: number
): Promise<EmeraldConfigResponseModel> => {
  const appState: IAppState = store.getState();
  const destinationUrl: string = addMarketToUrl('/api/contactus/v1/GetEmeraldConfig', market);
  const params: Record<string, string> = {};
  addAppNamesToParam(params, appState.GlobalState.appVer, appState.GlobalState.sourceApp);

  const data = {
    Host: host,
    Platform: platform,
    Market: market,
    Version: version,
    Namespace: namespace,
    LCID: LCID,
  };
  addExpGuidToParam(params);
  const config: AxiosRequestConfig = {
    params: params,
  };
  // eslint-disable-next-line no-return-await
  return await httpUtils.post<EmeraldConfigResponseModel>(destinationUrl, data, undefined, config);
};

export const updateAppVerCookieForAgavePaneAfterInitApi = async (): Promise<UserInfo> => {
  const appState: IAppState = store.getState();
  const data: string = `__RequestVerificationToken=${encodeURIComponent(
    appState.ContactState.SharedState.requestVerificationToken
  )}`;
  const params: Record<string, string> = {
    AppVer: appState.GlobalState.appVer,
  };
  const destinationUrl = inEmsSession() ? '/ems/auth/UserInfo' : '/home/UserInfo';
  addExpGuidToParam(params);
  const config: AxiosRequestConfig = {
    params: params,
  };
  // eslint-disable-next-line no-return-await
  return await httpUtils.post<UserInfo>(destinationUrl, data, FormUrlEncodedHeaders, config);
};
